import { PasswordEditor } from "../../editors/passwordEditor/index.mjs";
import { passwordRenderer } from "../../renderers/passwordRenderer/index.mjs";
export var CELL_TYPE = 'password';
export var PasswordCellType = {
  CELL_TYPE: CELL_TYPE,
  editor: PasswordEditor,
  renderer: passwordRenderer,
  copyable: false
};


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/passwordType/passwordType.mjs
// module id = 1115
// module chunks = 1